import './workingDetailsCard.scss';
import employeeImage from '../../../assets/icons/employee.png';
import repeatImage from '../../../assets/icons/repeat.png';
import grayRoundCloseButton from '../../../assets/icons/grayRoundCloseButton.png';

interface IWorkingDetailsCard {
    weeks: string;
    days: string;
    time: string;
    breakHours: string;
    hours: string;
    id:number;
    onClose(id:number): any;
}
const WorkingDetailsCard = ({ weeks, days, time, hours, breakHours, onClose ,id }: IWorkingDetailsCard) => {
    return (
        <div className="workingDetailsCardForAddSchedule">
            <div className="container">
                <div className="employeeImageWrapper">
                    <img src={employeeImage} alt="" className="employeeImage" />
                </div>

                <div className="timeContainer">
                    <div className="rowOne">
                        <div className="repeatImage">
                            <img src={repeatImage} alt="" className="employeeImage" />
                        </div>

                        <div className="weekCount">{weeks}</div>
                        <div className="cardDivider" />
                        <div className="days">{days}</div>
                    </div>

                    <div className="rowTwo">
                        <div className="time">{time}</div>
                        <div className="break">({breakHours})</div>
                    </div>
                </div>

                <div className="hoursContainer">
                    <div className="hoursText">{hours}</div>
                </div>
                <div className="closeButtonContainer">
                    <img
                        src={grayRoundCloseButton}
                        alt=""
                        className="grayRoundCloseButton"
                        onClick={() => {
                            onClose(id);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default WorkingDetailsCard;
